var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav-row"}},[( _vm.isAuth )?_c('font-awesome-icon',{attrs:{"id":"menuIcon","icon":"bars"},on:{"click":_vm.toggleSideNav}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }